export const intcmpMap = {
    calendar: 'skysport_sportsdata_calendario_detail-link',
    liveScoreAtpCalendar: 'skysport_sportsdata_calendario-atp_null',
    liveScoreWtaCalendar: 'skysport_sportsdata_calendario-wta_null',
    liveScoreAtpRanking: 'skysport_sportsdata_classifica-atp_null',
    liveScoreWtaRanking: 'skysport_sportsdata_classifica-wta_null',
    liveScoreAtpResults: 'skysport_sportsdata_tutti-i-risultati_null',
};